import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";
import {IFile} from "./sliceFiles";
import {IPerson} from "./slicePerson";

export interface IModal {
    error: boolean;
    messageError: any;

    success: boolean;
    messageSuccess: string;
    cardModal: boolean
    cardModel: ICardModel
    createRenameModal: boolean,
    createRenameModel: ICreateRename,

    moveModal: boolean,
    moveModalModel: IMove,
    mediaModal: boolean,
    mediaModalModel: IMedia,

    cameraModal: boolean,
    cameraModalModel: ICamera,

    cameraAllModal: boolean,
    cameraAllModalModel: ICameraAll,

    kettleModal: boolean,

    receiverModal: boolean,

    accessModal: boolean,
    accessModalModel: number | undefined

    iframeModal: boolean,
    iframeModalModel: IFrame,

    personModal: boolean,
    personModel: IPerson
}

export interface ICardModel {
    id: number;
    image: string;
    name: string,
    publicPath: string,
}

export interface ICreateRename {
    id?: number | null
    title: string;
    file?: IFile,
    isRename?: boolean
}

export interface IMove {
    title: string;
    file?: IFile,
    ids?: number[]

}

export interface ICamera {
    title: string;
    name: string,
}

export interface ICameraAll {
    title: string;
    name: Array<string>,
}

export interface IMedia {
    file: IFile,
    isAudio: boolean,
    publicPath?: string,

}

export interface IFrame {
    file?: IFile,
    publicPath?: string,
}

export const initialState: IModal = {
    error: false,
    messageError: '',
    success: false,
    messageSuccess: '',
    cardModal: false,
    cardModel: {} as ICardModel,
    createRenameModal: false,
    createRenameModel: {} as ICreateRename,
    moveModal: false,
    moveModalModel: {} as IMove,
    mediaModal: false,
    mediaModalModel: {} as IMedia,
    cameraModal: false,
    cameraModalModel: {} as ICamera,
    cameraAllModal: false,
    cameraAllModalModel: {} as ICameraAll,
    kettleModal: false,
    receiverModal: false,

    accessModal: false,
    accessModalModel: undefined,

    iframeModal: false,
    iframeModalModel: {} as IFrame,

    personModal: false,
    personModel: {} as IPerson

}


const slice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        showError: (state: IRootState, action: PayloadAction<any>) => {
            state.error = true;
            state.messageError = action.payload;
        },
        closeErrorModal: (state: IRootState) => {
            state.error = false;
        },
        showSuccess: (state: IRootState, action: PayloadAction<string>) => {
            state.success = true;
            state.messageSuccess = action.payload;
        },
        closeSuccessModal: (state: IRootState) => {
            state.success = false;
        },

        showCard: (state: IRootState, action: PayloadAction<ICardModel>) => {
            state.cardModal = true;
            state.cardModel = action.payload
        },
        closeCardModal: (state: IRootState) => {
            state.cardModal = false;
        },

        showCreateRenameModal: (state: IRootState, action: PayloadAction<ICreateRename>) => {
            state.createRenameModal = true;
            state.createRenameModel = action.payload
        },
        closeCreateRenameModal: (state: IRootState) => {
            state.createRenameModal = false;
        },
        showMoveModal: (state: IRootState, action: PayloadAction<IMove>) => {
            state.moveModal = true;
            state.moveModalModel = action.payload
        },
        closeMoveModal: (state: IRootState) => {
            state.moveModal = false;
            state.moveModalModel = {}
        },

        showMediaModal: (state: IRootState, action: PayloadAction<IMedia>) => {
            state.mediaModal = true;
            state.mediaModalModel = action.payload
        },
        closeMediaModal: (state: IRootState) => {
            state.mediaModal = false;
            state.mediaModalModel = {}
        },

        showCameraModal: (state: IRootState, action: PayloadAction<ICamera>) => {
            state.cameraModal = true;
            state.cameraModalModel = action.payload;
        },
        closeCameraModal: (state: IRootState) => {
            // window.location.reload()
            state.cameraModal = false;
            state.cameraModalModel = {}
        },

        showCameraAllModal: (state: IRootState, action: PayloadAction<ICameraAll>) => {
            state.cameraAllModal = true;
            state.cameraAllModalModel = action.payload;
        },
        closeCameraAllModal: (state: IRootState) => {
            // window.location.reload()
            state.cameraAllModal = false;
            state.cameraAllModalModel = {}
        },

        showKettleModal: (state: IRootState) => {
            state.kettleModal = true;
        },
        closeKettleModal: (state: IRootState) => {
            state.kettleModal = false;
        },

        showReceiverModal: (state: IRootState) => {
            state.receiverModal = true;
        },
        closeReceiverModal: (state: IRootState) => {
            state.receiverModal = false;
        },

        showAccessModal: (state: IRootState, action: PayloadAction<number>) => {
            state.accessModal = true;
            state.accessModalModel = action.payload
        },
        closeAccessModal: (state: IRootState) => {
            state.accessModal = false;
            state.accessModalModel = {}
        },

        showIframeModal: (state: IRootState, action: PayloadAction<IFrame>) => {
            state.iframeModal = true;
            state.iframeModalModel = action.payload
        },
        closeIframeModal: (state: IRootState) => {
            state.iframeModal = false;
            state.iframeModalModel = {}
        },

        showPersonModal: (state: IRootState, action: PayloadAction<IPerson>) => {
            state.personModal = true;
            state.personModel = action.payload
        },
        closePersonModal: (state: IRootState) => {
            state.personModal = false;
            state.personModel = {}
        },
    },
});

const {actions, reducer} = slice;

export {actions, reducer};
